<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import find from 'lodash/find'
import filter from 'lodash/filter'
import Store from '@/store'
import { TweenMax as Tween, Power1 } from 'gsap'

import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import TheFooter from '@/layout/the-footer'

import ScrollMarker from '@/components/scroll-marker'
import Dots from '@/components/dots'

import Scroller from '@/components/scroller'
import IntroSlide from './intro-slide'
import RegularSlide from './regular-slide'
import EmptySlide from './empty-slide'
import scrollMagic from 'scrollmagic'

export default {

  name: 'Homepage',

  components: {
    TransitionWrapper,
    TheFooter,
    ScrollMarker,
    Dots,
    Scroller,
    IntroSlide,
    RegularSlide,
    EmptySlide
  },

  data () {
    return {
      isAnimating: false,
      currentSlide: 0,
      scrolled: null,
      viewport: {
        scroll: null
      },
    }
  },

  computed: {
    pageContent () {
      return this.$store.state.pages.landings.main
    },

    slides () {
      const widget = filter(this.pageContent.widgets, { type : 'Presentation'})

      widget.items = widget.map((item, index) => {
        item.media.json = item.json.url
        item.media.loop = [8500, 9000, 10000][index] // slides loop timing
        return item
      })

      return widget.items
    },

    currentSlideData () {
      return this.slides[this.currentSlide - 1]
    },

    slidesAmount () {
      return this.slides.length
    },

    navigationItems () {
      return [
        { label: 'Intro' },
        ...this.slides.map((item) => {
          return { label: item.label }
        })
      ]
    },

    isIntro () {
      return this.currentSlide === 0
    },

    isLast () {
      return this.currentSlide === this.slidesAmount + 1
    }
  },

  watch: {
    'currentSlide': 'commitCurrentSlide'
  },

  beforeRouteEnter: async (to, from, next) => {
    Store.commit('startLoading')
    const page = await Store.dispatch('pages/fetchLanding', 'main')
    const errors = []

    if (!page.title) errors.push('Home page must have a title.')
    if (!page.description) errors.push('Home page must have a description.')
    if (!filter(page.widgets, { type : 'Presentation'})) errors.push('Home page must have a presentation widget.')

    Store.commit('endLoading')

    if (errors.length > 0) {
      next({
        path: '/' + (from.params.lang || 'ua') + '/error',
        query: { code: 500, errors }
      })
      return
    }

    next()
  },

  beforeRouteUpdate: async (to, from, next) => {
    if (from.params.lang === to.params.lang) {
      next()
      return
    }

    Store.commit('startLoading')
    const page = await Store.dispatch('pages/fetchLanding', 'main')
    const errors = []

    if (!page.title) errors.push('Home page must have a title.')
    if (!page.description) errors.push('Home page must have a description.')
    if (!filter(page.widgets, { 'type': 'Presentation' })) errors.push('Home page must have a presentation widget.')

    Store.commit('endLoading')

    if (errors.length > 0) {
      next({
        path: '/' + (from.params.lang || 'ua') + '/error',
        query: { code: 500, errors }
      })
      return
    }

    next()
  },

  mounted () {
    this.commitCurrentSlide();
    this.setTitle();
    this.$root.$on('keypress', this.onKeypress);

    //scrollMagic
    let vueComponent = this,
        duration = 4;

    window.addEventListener("resize", function() {
      scrollMagicScene.duration(window.innerHeight*duration)
    });

    window.scrollMagicController = new scrollMagic.Controller();
    window.scrollMagicScene = new scrollMagic.Scene({
        triggerElement:'.magicTrigger1',
        triggerHook:0.5,
        duration:window.innerHeight*duration
    })
      .addTo(window.scrollMagicController);

    window.scrollMagicScene.on('progress', function (event) {

      if(event.progress >= 0 && event.progress <= 0.2){
        vueComponent.currentSlide = 0
      }
      if(event.progress >= 0.2 && event.progress <= 0.4){
        vueComponent.currentSlide = 1
      }
      if(event.progress >= 0.4 && event.progress <= 0.6){
        vueComponent.currentSlide = 2
      }
      if(event.progress >= 0.6 && event.progress <= 0.8){
        vueComponent.currentSlide = 3
      }
      if(event.progress >= 0.8 && event.progress <= 1){
        vueComponent.currentSlide = 4
      }
    });
  },

  beforeDestroy () {
    this.$root.$off()
  },

  methods: {

    setTitle(){
      let title = document.getElementsByTagName('title')[0];
      return title.text = this.pageContent.meta.title;
    },

    commitCurrentSlide () {
      Store.commit('setMainPageIntroSlide', {
        current: this.currentSlide,
        total: this.slides.length
      })
    },

    prevSlide () {
      if (this.isAnimating) return

      this.currentSlide = Math.max(this.currentSlide - 1, 0)
    },

    nextSlide () {
      if (this.isAnimating) return

      this.currentSlide = Math.min(this.currentSlide + 1, this.slidesAmount + 1)
    },

    onKeypress (event) {
      if (event.keyCode === 38) this.prevSlide()
      if (event.keyCode === 40) this.nextSlide()
    },

    enter (el, done) {
      Tween.from(el, 1, {
        autoAlpha: 0,
        ease: Power1.easeOut,
        onComplete: done
      })
    },

    leave (el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done()
      } else {
        Tween.to(el, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          onComplete: done
        })
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.homepage
  .homepage__content(v-if="!$store.getters.isLoading")
    .magicTriggerBox
      .magicTrigger1
    .homepage__slider.fullscreen-slider(
      ref="scroller",
      :class="{ 'is-intro': isIntro, 'is-last': isLast }",
      :block="isAnimating || $store.getters.isPopupOpened")

      transition-wrapper(
        mode="out-in",
        :appear="true",
        @transition-start="isAnimating = true",
        @transition-end="isAnimating = false")

        intro-slide.fullscreen-slider__slide(
          v-if="isIntro",
          :label="pageContent.title",
          :head="pageContent.description")

        <!--regular-slide.fullscreen-slider__slide(-->
          <!--v-if="!isLast",-->
          <!--:slides="slides")-->

        regular-slide.fullscreen-slider__slide(
          v-else-if="!isLast",
          :slides="slides",
          :key="currentSlide",
          :image="currentSlideData.media.url",
          :media="currentSlideData.media.json",
          :media-loop="currentSlideData.media.loop",
          :title="currentSlideData.title",
          :text="currentSlideData.description")

        empty-slide.fullscreen-slide__slide(v-else :key="currentSlide")

      transition-wrapper(:appear="true")
        dots.fullscreen-slider__navigation.is-intro(
          v-if="isIntro",
          :key="isIntro",
          :items="navigationItems",
          :current="currentSlide")

        dots.fullscreen-slider__navigation(
          v-else,
          :key="isIntro",
          :items="navigationItems",
          :current="currentSlide")

      //transition-wrapper(:appear="true")
        scroll-marker.fullscreen-slider__scroll-button(v-if="!isLast" @click="nextSlide")

    the-footer.homepage__footer(
      :block="!isLast"
      @scroll-up="prevSlide")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>
.magicTriggerBox
  width: 100%
  height: 100%
.magicTrigger1
  width: 100%
  height: 400vh
.homepage
  /*position absolute*/
  /*top 0*/
  /*left 0*/
  width 100%
  height 100%
  display flex

  &__content
    width 100%
    height 100%
    display: flex

  &__slider
    z-index: 3;
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0
    left: 0

  &__footer
    z-index 1
    position fixed
    left 0
    bottom 0
    width 100%

.fullscreen-slider
  display flex
  flex-direction column
  background-color primary
  transition background-color 1s, transform 1s

  &.is-intro
    background-color blue

  &.whiteBackground
    background-color: white

  &.is-last
    transform translateY(-690px) // footer-main height + footer-mini

    +mobile()
      transform translateY(-475px)

  &__slide
    display flex
    justify-content center
    align-items center
    width 100%
    height: 100%
    color #fff
    position: absolute
    top: 0;
    left: 0;
    z-index:0;

  &__navigation
    position fixed
    top 40px
    left 0
    right 0
    margin 0 auto

    +mobile()
      &.dot-nav
        display none

    &.is-intro
      top 0
      bottom 0
      right calc((100vw - 894px) / 2)
      left auto
      margin auto 0
      width auto !important

  &__scroll-button
    z-index 2
    position absolute
    left 0
    right 0
    bottom 0
    margin 0 auto

</style>



// WEBPACK FOOTER //
// index.vue?9e0ba2fe